const joinDatasets = (arr1, arr2, compareKey) => {
  const map = new Map([...arr1, ...arr2].map((obj) => [obj[compareKey], obj]));

  return Array.from(map.values());
};

export default joinDatasets;
